import API from "@/models/API";

export default class MultipleCoupons {
    constructor(item = {}) {
        this.gift_category_id = item.gift_category_id || null;
        this.gift_title = item.gift_title || "";
        this.gift_description = item.gift_description || "";
        this.price = item.price || null;
        this.maximum = item.maximum || null;
        this.valid_days = item.valid_days || null;
        this.notification = item.notification || {
            redeemed_coupons_report: {
                emails: ["","",""],
                frequency: ""
            },
            all_coupons_report: {
                emails: ["","",""],
                frequency: ""
            }
        };
        this.code = item.code || "";
        this.coupon_id = item.coupon_id || 0;
    }

    static get = (query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/coupons/multiple${query}`);

    static create = (body) =>
        API.post(`/companies/${localStorage.getItem("storeId")}/coupons/multiple`,body);
    
    static getCouponClaims = (id, query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/coupons/multiple/${id}${query}`);
    
        static exportFile = body =>
                API.post(
                    `/companies/${localStorage.getItem(
                        "storeId"
                    )}/export/all-coupons-status-report`,
                    body
            );
            
        static getExportedFile = () =>
            API.get(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/export/all-coupons-status-report`
            );
    
        static deleteExportedFile = id =>
            API.delete(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/export/all-coupons-status-report/${id}`
            );
}
